module.exports = __webpack_public_path__ + "static/media/3.750eb7fd.jpg";